module.exports = __webpack_public_path__ + "img/yh.712f792f.png";